<template>
  <div>
    <div class="d-flex align-center filter-box__header pa-3">
      <div class="text-h6 font-weight-black">Filtres</div>
      <v-spacer />
      <v-btn small fab color="error" @click="$emit('cancel')">
        <v-icon>mdi-filter-remove</v-icon>
      </v-btn>
      <v-btn small fab color="success" class="ml-2" @click="$emit('apply')">
        <v-icon>mdi-filter-check</v-icon>
      </v-btn>
    </div>

    <div class="filter-box__body pa-4">
      <v-row>
        <v-col cols="12" md="4">
          <div class="d-flex flex-no-wrap align-center">
            <div v-if="imgCustomerLogo" class="mr-2">
              <v-avatar tile size="52">
                <v-img :src="imgCustomerLogo" max-width="80" />
              </v-avatar>
            </div>
            <v-select
              v-if="!isOnlyOneCustomer"
              v-model="customer"
              :items="customers"
              item-text="name"
              item-value="id"
              label="Client"
              dense
              clearable
            />
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            v-model="agency"
            :items="agencies"
            item-text="name"
            item-value="id"
            label="Agence"
            :loading="isLoadingAgencies"
            :disabled="!customer"
            dense
            clearable
          />
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            v-model="role"
            :items="roleOptions"
            item-text="label"
            item-value="value"
            label="Role"
            dense            
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-subheader class="px-0">Statut collaborateurs</v-subheader>
          <v-radio-group v-model="status" column>
            <v-radio label="Tous les collaborateurs" color="primary" value="all" />
            <v-radio label="Collaborateurs en activité" color="primary" value="0" />
            <v-radio label="Collaborateurs ayant quitté la société" color="primary" value="1" />
          </v-radio-group>
        </v-col>
        <v-col cols="12" md="6" class="d-flex align-center">
          <v-switch v-model="isLocked" inset :label="lockLabel" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACollaboratorFilterBox",
  props: {
    userFilters: {
      type: Object,
      required: true
    },
    customers: {
      type: Array,
      required: true
    },
    isOnlyOneCustomer: {
      type: Boolean,
      required: true
    },
    imgCustomerLogo: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      agencies: [],
      isLoadingAgencies: false,
      roleOptions: [
        { label: "Tous", value: "all" },
        { label: "Administrateur client", value: 0 },
        { label: "Gestionnaire", value: 1 },
        { label: "Collaborateur", value: 2 }
      ]
    }
  },
  computed: {
    customer: {
      get() {
        return this.userFilters.customer
      },
      set(value) {
        this.updateUserFilters({ customer: value, agency: undefined })
      }
    },
    agency: {
      get() {
        return this.userFilters.agency
      },
      set(value) {
        this.updateUserFilters({ agency: value })
      }
    },
    role: {
      get() {
        return this.userFilters.role
      },
      set(value) {
        this.updateUserFilters({ role: value })
      }
    },
    isLocked: {
      get() {
        return this.userFilters.isLocked || false
      },
      set(value) {
        this.updateUserFilters({ isLocked: value })
      }
    },
    status: {
      get() {
        return this.userFilters.status || "all"
      },
      set(value) {
        this.updateUserFilters({ status: value })
      }
    },
    lockLabel() {
      return this.isLocked ? "Utilisateurs verrouilles" : "Utilisateurs deverrouilles"
    }
  },
  watch: {
    customer: {
      immediate: true,
      handler(value, previous) {        
        if (value !== previous) {
          this.updateUserFilters({ agency: undefined })
        }        
        this.loadAgencies(value)
      }
    }
  },
  methods: {
    updateUserFilters(patch) {
      this.$emit("update:userFilters", { ...this.userFilters, ...patch })
    },
    loadAgencies(customerId) {            
      this.agencies = []
      if (customerId) {
        this.isLoadingAgencies = true  
        let url = `places?cstm=${customerId}`                     
        this.$http
          .get(url)            
          .then(response => {                        
              if (response.status == 200) {
                this.agencies = response.data                                                
              } 
                         
          })
          .catch(error => {                
              this.isLoading = false
              if (error.response.status === 401) this.$root.$emit("logout"); 
              else this.$root.$emit("serverError", error);     
          })
        
        this.isLoadingAgencies = false
        return
      }      
    }
  }
}
</script>
